import {COUNTRIES, COUNTRY} from './env';

const DICTIONARY = [
    'TOBACCO',
    'ALCOHOL',
    'MEDICATIONS',
    'VETERINARY',
    'DRINKS',
    'COFFEE',
    'FUEL',
    'BIOFUELS',
] as const;

export const ProductGroupsMap: Record<COUNTRIES, typeof DICTIONARY[number][]> = {
    BA: [...DICTIONARY],
    CAR: [
        'TOBACCO',
        'ALCOHOL',
        'MEDICATIONS',
        'VETERINARY',
        'DRINKS',
        'COFFEE',
        'FUEL',
        'BIOFUELS',
    ],
    NG: ['TOBACCO', 'ALCOHOL', 'MEDICATIONS', 'COFFEE', 'FUEL', 'BIOFUELS'],
    TJ: ['TOBACCO', 'ALCOHOL', 'MEDICATIONS', 'COFFEE', 'FUEL', 'BIOFUELS'],
};

export const ProductGroups = Object.fromEntries(
    ProductGroupsMap[COUNTRY ?? 'CAR'].map((c) => [c, c] as const),
) as Record<ProductGroup, ProductGroup>;
export type ProductGroup = typeof DICTIONARY[number];
